import brands from '@/brands/brands.js';

export function brandDetector() {
    var url = '/static/favicon/';
    document.head.querySelector("[name=favicon]").href = url + 'favicon.ico';

    return brands;
}


// WEBPACK FOOTER //
// ./src/brands/index.js